var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "catalog-settings-input" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.localeOptions, function (option) {
        return _c("tr", { key: option.code }, [
          _c("th", [
            _c(
              "label",
              { staticClass: "label" },
              [
                _c("gb-flag", {
                  attrs: {
                    code: option.flagCode || option.code,
                    size: "small",
                    iconPath: "/assets/img/flags/",
                  },
                }),
                _vm._v(
                  "\n                " + _vm._s(option.name) + ":\n            "
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "pl-4" }, [
            _c(
              "div",
              { staticClass: "control" },
              [
                _c("multiselect", {
                  attrs: {
                    value: _vm.getYears(option),
                    options: _vm.getYearOptions(option),
                    multiple: true,
                    placeholder: "Katalogjahre",
                  },
                  on: { input: (value) => _vm.setYears(option, value) },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "pl-4" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                staticClass: "input",
                attrs: { type: "text" },
                domProps: { value: _vm.getPage(option) },
                on: {
                  input: (event) => _vm.setPage(option, event.target.value),
                },
              }),
            ]),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th"),
      _vm._v(" "),
      _c("td", { staticClass: "pl-4" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Jahre:")]),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "pl-4" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Seitenzahl:")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }